
export const AssetNotificationValidation = (formData) => {
    const errors = {};

    if (!formData.vc_Email || !formData.vc_Email.trim()) {
        errors.vc_Email = 'This field is required';
    } else if (!isValidEmail(formData.vc_Email)) {
        errors.vc_Email = 'Please enter a valid email address';
    }

    if (!formData.snt_CheckFrequency || formData.snt_CheckFrequency === "0") {
        errors.snt_CheckFrequency = 'This field is required';
    }
    if (!formData.dt_LastFrequencyCheck || !formData.dt_LastFrequencyCheck.trim()) {
        errors.dt_LastFrequencyCheck = 'This field is required';
    }

    

    return errors;
};
const isValidEmail = (email) => {
    // You can implement a regex or use a library like validator.js to validate email format
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
